import './ArchivedSessionsTable.css';
import { useCategories } from '../hooks/useCategories';

/**
 * ArchivedSessionsTable Component
 * Renders archived sessions in a table layout (no pagination – all on one page).
 * Columns: Name, Presenter, Category, Description, Guest Speaker
 */
const ArchivedSessionsTable = ({ sessions }) => {
  const { byCode: catByCode } = useCategories();

  if (!sessions || sessions.length === 0) {
    return <div className="no-results">No archived sessions found.</div>;
  }

  return (
    <div className="archived-table-wrapper">
      <div className="archived-table-count">
        Showing {sessions.length} session{sessions.length !== 1 ? 's' : ''}
      </div>
      <table className="archived-sessions-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Segment</th>
            <th>Presenter</th>
            <th>Category</th>
            <th>Description</th>
            <th>Guest Speaker</th>
          </tr>
        </thead>
        <tbody>
          {sessions.map((session) => {
            const hasLink = session.sabaLink && session.sabaLink.toLowerCase() !== 'coming soon';
            return (
            <tr key={session.id}>
              <td className="archived-col-name">
                {hasLink ? (
                  <a href={session.sabaLink} target="_blank" rel="noopener noreferrer">
                    {session.name}
                  </a>
                ) : (
                  session.name
                )}
              </td>
              <td className="archived-col-segment" data-label="Segment">{session.segment || '—'}</td>
              <td className="archived-col-presenter">{session.presenter}</td>
              <td className="archived-col-category">{catByCode[session.category]?.name || session.category}</td>
              <td className="archived-col-description">{session.description}</td>
              <td className="archived-col-guest">
                {session.guestSpeaker === 'Yes' ? '🎤 Yes' : ''}
              </td>
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ArchivedSessionsTable;
